import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms73e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms73e/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    sendParams = {
      p_codempid_query: searchParams.codempid3,
      p_codcomp: searchParams.codcomp
    }
    if (isMock) return generator(mocker.index())
    let param = searchParams.year + '/' + searchParams.codcours2 + '/' + searchParams.numclseq
    return instance().get(endpoint + '/hrms73e/index/' + param, { params: sendParams })
  },
  getDetail ({ searchIndex, indexSelected }) {
    let sendParams = {}
    sendParams = {
      p_codeval: indexSelected.val_code,
      p_dteeval: indexSelected.val_date,
      p_codform: indexSelected.codform
    }
    if (isMock) return generator(mocker.detail())
    let param = indexSelected.codempid + '/' + searchIndex.year + '/' + searchIndex.codcours2 + '/' + searchIndex.numclseq + '/' + sendParams.p_codeval + '/' + sendParams.p_dteeval.replace(/\//g, '')
    return instance().get(endpoint + '/hrms73e/table1Detail/' + param)
  },
  getDetailForm (detailFrom) {
    if (isMock) return generator(mocker.detail())
    const params = detailFrom.p_codform
    return instance().get(endpoint + '/hrms73e/detailCodform/' + params)
  },
  postSave ({ searchIndex, indexSelected, detail }) {
    let sendParams = {
      param_json: JSON.stringify({
        codempid_query: indexSelected.codempid,
        dteyear: searchIndex.year,
        codcours: searchIndex.codcours2,
        numclseq: searchIndex.numclseq,
        codeval: indexSelected.val_code,
        dteeval: indexSelected.val_date,
        detail: detail.tab1.detail,
        table1: detail.tab1.table1
      })
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms73e/table1DetailSave', sendParams)
  },
  postDelete ({ searchIndex, dataRowsHasFlg }) {
    let param = {
      p_dteyear: searchIndex.dteyear,
      p_codcours: searchIndex.codcours2,
      p_numclseq: searchIndex.numclseq,
      p_codempid: searchIndex.codempid,
      p_val_code: searchIndex.val_code,
      p_val_date: searchIndex.val_date,
      p_codform: searchIndex.codform
    }
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
    }
    let sendParams = {
      param_json: JSON.stringify(dataRowsHasFlg)
    }

    if (isMock) return generator(mocker.delete())
    return instance().post(endpoint + '/hrms73e/table1Delete', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms73e/index.js